import { render } from "./PageReferansEkle.vue?vue&type=template&id=7791b101&scoped=true"
import script from "./PageReferansEkle.vue?vue&type=script&lang=js"
export * from "./PageReferansEkle.vue?vue&type=script&lang=js"

import "./PageReferansEkle.vue?vue&type=style&index=0&id=7791b101&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7791b101"

export default script